module.exports = __webpack_public_path__ + "static/img/cooperationBg.23f90ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cooperationBg.png
// module id = J642
// module chunks = 1